import {Injectable} from '@angular/core';
import {Roadtrip} from '../../core/api/resources/roadtrip-list.resource';
import {UnrRouteListItem} from '../roadtrip-list/roadtrip-list-item/model/route-list-item.model';

@Injectable({
  providedIn: 'root'
})
export class MyRoutesStateService {
  get roadTrips(): UnrRouteListItem[] {
    return this._roadTrips;
  }

  set roadTrips(value: UnrRouteListItem[]) {
    this._roadTrips = value;
  }

  private _roadTrips: UnrRouteListItem[] = [];
}
